import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, checkAuth } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    if (user) {
      setIsAuthenticated(true);
      return;
    }

    const verify = async () => {
      const authenticated = await checkAuth();
      setIsAuthenticated(authenticated);
    };

    if (!loading) {
      verify();
    }
  }, [user, checkAuth, loading]);

  if (isAuthenticated === null || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8]">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#AF2628] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#6E6E73]">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
